import React, { useCallback, useEffect, useState } from "react";
import io from "socket.io-client";
import { red, purple, green, orange, yellow } from "@mui/material/colors";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  Grid,
  Card,
  Menu,
  MenuItem,
  CircularProgress,
  IconButton,
  Switch,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
// import Switch from '@mui/joy/Switch';
import { useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import EmptyData from "../../components/EmptyData";
// import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  getDatabase,
  ref,
  onValue,
  set,
  get,
  update,
  child,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
} from "firebase/database";
import BatteryStatusChip from "./BatteryStatusChip";
import UserConnected from "./userConnected";
import Movement from "./movement";
import UserFBK from "./userFBK";
import Zone from "./zone";
import socketService from "../../socket/SocketService";
import LongMenu from "Utils/action";
import File from "Utils/file";
import Chat from "Utils/chat";

const Escort = () => {
  const getUserState = useSelector((state) => state?.data?.getUserState);

  const [status, setStatus] = useState("Connecting...");
  const [loading, setLoading] = useState(false);
  const [searchTxt, setSearchText] = useState("");
  const [users, setUsers] = useState([]);
  const { userId, wellBeingCheckId } = useParams();
  const [rows, setRows] = useState([]);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  // const getData = () => {
  //   const getAdminInfo = JSON.parse(localStorage.getItem("user"));
  //   const getAdminState = getAdminInfo?.state;
  //   const useradmin = getAdminInfo?.superAdmin;
  //   setCheckSuperAdmin(useradmin);
  //   setAdminState(getAdminState);

  //   const db = getDatabase();
  //   const escortRef = ref(db, "escort");
  //   const userescortRef = ref(db, "users");

  //   const filterDataByState = (escort, userData) => {
  //     const escortState = userData?.state;
  //     if (useradmin) {
  //       return getUserState === "" || getUserState === "All State" || getUserState === escortState;
  //     } else {
  //       return escortState === getAdminState;
  //     }
  //   };

  //   onChildAdded(escortRef, async (snapshot) => {
  //     const escort = snapshot.val();
  //     const escortUserId = escort.userId;

  //     const userRef = child(ref(db, "users"), escortUserId);
  //     const userSnapshot = await get(userRef);
  //     const userData = userSnapshot.val();

  //     // Only add escort if it matches the state filter
  //     if (filterDataByState(escort, userData)) {
  //       await fetchFullUserObject(escort, userData);
  //       console.log(escort, snapshot.key);
  //     }
  //   });

  //   onChildChanged(escortRef, async (snapshot) => {
  //     const escort = snapshot.val();
  //     const escortUserId = escort.userId;

  //     const userRef = child(ref(db, "users"), escortUserId);
  //     const userSnapshot = await get(userRef);
  //     const userData = userSnapshot.val();
  //     if (filterDataByState(escort, userData)) {
  //       console.log(escort, snapshot.key);
  //     }
  //   });

  //   onChildRemoved(escortRef, async (snapshot) => {
  //     const escort = snapshot.val();
  //     const escortUserId = escort.userId;

  //     const userRef = child(ref(db, "users"), escortUserId);
  //     const userSnapshot = await get(userRef);
  //     const userData = userSnapshot.val();

  //     if (filterDataByState(escort, userData)) {
  //       console.log(escort, snapshot.key);
  //       var removedData = escort;
  //       setAllData((prevData) => {
  //         const filteredData = prevData.filter((item) => item?.userId !== removedData?.userId);
  //         return filteredData;
  //       });
  //     }
  //   });

  //   onChildChanged(userescortRef, (snapshot) => {
  //     const userData = snapshot.val();
  //     console.log("snapshot.key", userData, snapshot.key);
  //     setAllData((prevData) => {
  //       const updatedData = prevData.map((item) => {
  //         if (item.userId === snapshot.key) {
  //           return { ...item, userData: userData };
  //         }
  //         return item;
  //       });
  //       return updatedData;
  //     });
  //   });
  // };

  // const fetchFullUserObject = async (escort, userData) => {
  //   console.log("userId ", escort.userId);
  //   const db = getDatabase();
  //   const userRef = child(ref(db, "users"), escort?.userId);
  //   const userSnapshot = await get(userRef);

  //   const userDetails = userSnapshot.val();
  //   // console.log("userDetails", userDetails);
  //   setAllData((prevData) => {
  //     const filteredData = [...prevData, { userData: userDetails, ...escort }];
  //     const newStateFilteredData =
  //       getUserState === "" || getUserState === "All State"
  //         ? filteredData
  //         : filteredData.filter((item) => item?.userData?.state === getUserState);

  //     //console.log("newStateFilteredData", newStateFilteredData);
  //     const uniqueData = newStateFilteredData.filter(
  //       (value, index, self) => index === self.findIndex((t) => t.userId === value.userId)
  //     );
  //     // console.log("uniqueData", uniqueData);

  //     return uniqueData;
  //   });
  // };

  //const getUserState = useSelector((state) => state?.data?.getUserState);

  const getData = () => {
    const getAdminInfo = JSON.parse(localStorage.getItem("user"));
    const getAdminState = getAdminInfo?.state;
    const useradmin = getAdminInfo?.superAdmin;
    setCheckSuperAdmin(useradmin);
    setAdminState(getAdminState);

    const db = getDatabase();
    const escortRef = ref(db, "escort");
    const userescortRef = ref(db, "users");

    const filterDataByState = (escort, userData) => {
      const escortState = userData?.state;
      // if (
      //   useradmin ||
      //   getUserState === "" ||
      //   getUserState === "All State" ||
      //   getUserState === escortState
      // ) {
      //   return true;
      // }
      // return escortState === getAdminState;

      if (!useradmin) {
        return escortState === getAdminState;
      } else {
        if (
          useradmin ||
          getUserState === "" ||
          getUserState === "All State" ||
          getUserState === escortState
        ) {
          return true;
        }
      }

      return escortState === getAdminState;
    };

    onChildAdded(escortRef, async (snapshot) => {
      const escort = snapshot.val();
      const escortUserId = escort.userId;

      const userRef = child(ref(db, "users"), escortUserId);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();

      // Only add escort if it matches the state filter
      if (filterDataByState(escort, userData)) {
        await fetchFullUserObject(escort, userData);
        console.log(escort, snapshot.key);
      }
    });

    onChildChanged(escortRef, async (snapshot) => {
      const escort = snapshot.val();
      const escortUserId = escort.userId;

      const userRef = child(ref(db, "users"), escortUserId);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();

      if (filterDataByState(escort, userData)) {
        console.log(escort, snapshot.key);
      }
    });

    onChildRemoved(escortRef, async (snapshot) => {
      const escort = snapshot.val();
      const escortUserId = escort.userId;

      const userRef = child(ref(db, "users"), escortUserId);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();

      if (filterDataByState(escort, userData)) {
        console.log(escort, snapshot.key);
        var removedData = escort;
        setAllData((prevData) => {
          const filteredData = prevData.filter((item) => item?.userId !== removedData?.userId);
          return filteredData;
        });
      }
    });

    onChildChanged(userescortRef, (snapshot) => {
      const userData = snapshot.val();
      console.log("snapshot.key", userData, snapshot.key);
      setAllData((prevData) => {
        const updatedData = prevData.map((item) => {
          if (item.userId === snapshot.key) {
            return { ...item, userData: userData };
          }
          return item;
        });
        return updatedData;
      });
    });
  };

  const fetchFullUserObject = async (escort, userData) => {
    console.log("userId ", escort.userId);
    const db = getDatabase();
    const userRef = child(ref(db, "users"), escort?.userId);
    const userSnapshot = await get(userRef);

    const userDetails = userSnapshot.val();
    setAllData((prevData) => {
      const filteredData = [...prevData, { userData: userDetails, ...escort }];
      const newStateFilteredData =
        getUserState === "" || getUserState === "All State"
          ? filteredData
          : filteredData.filter((item) => item?.userData?.state === getUserState);

      const uniqueData = newStateFilteredData.filter(
        (value, index, self) =>
          value.userId && index === self.findIndex((t) => t.userId === value.userId)
      );

      return uniqueData;
    });
  };

  const handleToggle = async (user, index) => {
    console.log(user, index, allData[index].tracking);

    // Toggle the tracking state in allData
    setAllData((prevData) => {
      const updatedData = [...prevData]; // Create a shallow copy of the previous state
      updatedData[index] = { ...updatedData[index], tracking: !updatedData[index].tracking }; // Toggle the tracking property for the specific user
      return updatedData; // Return the updated array
    });

    // Emit the updated tracking state to the server
    socketService.emit("trackingData", {
      socketId: user.userData.socketId,
      tracking: !allData[index].tracking, // Send the toggled value (the new value after toggling)
    });

    toast.info(`Tracking has been updated`, {
      autoClose: 3000,
      position: toast.POSITION.TOP_CENTER,
    });
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }
    getData();
  }, [getUserState]);

  return (
    <DashboardLayout>
      <MDBox pt={12} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  sx={{
                    textAlign: "center", // Center text
                  }}
                >
                  <ToastContainer />
                  <MDTypography
                    variant="h6"
                    color="white"
                    sx={{
                      fontWeight: "bold", // Make text bold
                      fontSize: "1.5rem", // Adjust font size
                    }}
                  >
                    {checkSuperAdmin
                      ? getUserState === ""
                        ? "ALL STATE "
                        : `${getUserState?.toUpperCase()} STATE `
                      : `${adminState?.toUpperCase()} STATE `}
                    ESCORT USERS DEVICE EVENTS DASHBOARD
                  </MDTypography>
                </MDBox>
                {allData.length > 0 ? (
                  <MDBox>
                    <TableContainer component={Paper}>
                      <Table aria-label="user table">
                        <TableHead>
                          <TableBody>
                            <TableCell>User Name</TableCell>
                            <TableCell align="center">Battery Indicator</TableCell>
                            <TableCell align="center">User Connected</TableCell>
                            {/* <TableCell align="center">Location status</TableCell> */}
                            <TableCell align="center">Zone Fencing</TableCell>
                            <TableCell align="center">Movement Indicator</TableCell>
                            <TableCell align="center">Tracking</TableCell>
                            <TableCell align="center">UserFBK</TableCell>
                            <TableCell align="center">Last Known Location</TableCell>
                            <TableCell align="center">File</TableCell>
                            {/* <TableCell align="center">Chat</TableCell> */}
                            <TableCell align="center">Action</TableCell>
                            {allData.map((user, index) => (
                              <TableRow key={index} sx={{ height: "auto" }}>
                                <TableCell sx={{ padding: "6px" }} component="th" scope="row">
                                  <Avatar
                                    src={user?.userData?.userImage}
                                    alt={user?.userData?.userName}
                                    style={{ marginRight: "10px" }}
                                  />
                                  {user?.userData?.userName}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <BatteryStatusChip
                                    status={(user?.userData?.BatteryIndicator * 100).toFixed(2)}
                                  />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <UserConnected status={user?.userData?.socketId} />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <Zone status={user?.zone_fenceing} />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <Movement status={user?.userData?.is_moving} />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <Switch
                                    checked={user?.userData?.tracking}
                                    onChange={() => handleToggle(user, index)}
                                    color="primary"
                                    borderRadius="5px"
                                  />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <UserFBK status={user?.userData?.userFBK} />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <Link to={`/shortDistanceEscort/${user?.userId}`}>
                                    <button className="btn btn-danger btn-sm">Track</button>
                                  </Link>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <File props={user} />
                                  {/* <Chat /> */}
                                </TableCell>
                                {/* <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <button className="btn btn-danger btn-sm" onClick={handleOpen}>
                                    Chat
                                  </button>
                                  <Chat open={open} onClose={handleClose} />
                                </TableCell> */}
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <LongMenu props={user} />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </MDBox>
                ) : (
                  <EmptyData />
                )}
              </Card>
            </Grid>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};
export default React.memo(Escort);
